import { render, staticRenderFns } from "./xiyiDetail.vue?vue&type=template&id=1b475052&scoped=true&"
import script from "./xiyiDetail.vue?vue&type=script&lang=js&"
export * from "./xiyiDetail.vue?vue&type=script&lang=js&"
import style0 from "./xiyiDetail.vue?vue&type=style&index=0&id=1b475052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b475052",
  null
  
)

export default component.exports